export const UPDATE_MERCHANT_APPLICATION_DOCUMENTS_MUTATION = gql`
    mutation updatedMerchantApplicationDocuments($input: AddMerchantApplicationInput!) {
        updateMerchantSupportingDocuments(input: $input) {
            id
            status
            supportingDocuments
        }
    }
`;
